"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var FetchError = (function (_super) {
    __extends(FetchError, _super);
    function FetchError(response) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var _this = _super.apply(this, args) || this;
        _this.response = response;
        Object.setPrototypeOf(_this, FetchError.prototype);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, FetchError);
        }
        return _this;
    }
    return FetchError;
}(Error));
exports.FetchError = FetchError;
//# sourceMappingURL=FetchError.js.map


// WEBPACK FOOTER //
// ../src/FetchError.ts